import easing from "../utils/easing";
import Easing from "../utils/easing";
import SimplexNoise from "./SimplexNoise";
const simplex = new SimplexNoise();
const min = 0;
const max = 5;
export default class EyeLine {
  constructor(x, y, size = 5, ctx, color, scale = 0, lines, index) {
    this.x = x;
    this.y = y;
    this.size = size;
    this.ctx = ctx;
    this.direction = Math.random() * Math.PI * 2;
    this.lifeSpanStart = Math.floor(Math.random() * (max - min + 1) + min);
    this.lifeSpan = this.lifeSpanStart;
    this.opacity = 1;
    this.gravity = 2;
    this.color = color;
    this.scale = scale;
    this.lines = lines;
    this.index = index;
  }
  draw() {
    this.ctx.save();
    this.ctx.translate(this.x, this.y);
    this.ctx.beginPath();
    this.ctx.fillStyle = `rgba(${this.color[0]},${this.color[1]},${this.color[2]},${this.opacity})`;
    this.ctx.arc(0, 0, this.size, 0, Math.PI * 2, true);
    this.ctx.fill();
    this.ctx.closePath();
    this.ctx.restore();
  }

  update(time) {
    let progress = this.index / this.lines;
    let angle = 2 * Math.PI * progress;
    let frequency = 1;
    this.scale = 100 + time * 100;
    let n = Easing.linear(
      simplex.noise3D(time, Math.sin(angle), this.index) * 20
    );
    this.x = Math.cos(angle) * this.scale + n * frequency;
    this.y = Math.sin(angle) * this.scale + n * frequency;
    this.opacity = 1-Math.pow((time * 100) / 3 / 100*2-1, 4);
    this.draw();
    0.5
  }
}
